var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFridge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.132 294.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fridge"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.132,23.465V251.19c0,1.488-.5,2.933-1.419,4.103l-27.147,34.55L146.761,.399l26.393,17.527c1.859,1.23,2.978,3.31,2.978,5.54Z",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.524,
    y: 289.214,
    width: 133.428,
    height: 4.882,
    rx: 1.302,
    ry: 1.302,
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.476,
    height: 290.794,
    rx: 3.254,
    ry: 3.254,
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.982,
    width: 148.477,
    height: 3.905,
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 111.886,
    width: 148.476,
    height: 0.684,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.982,
    width: 148.477,
    height: 0.682,
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.583,112.57l-7.615,10.218c-.814,1.089-2.105,1.737-3.464,1.737H21.572c-1.358,0-2.65-.648-3.46-1.737l-7.618-10.218h1.242l7.173,9.624c.628,.84,1.614,1.335,2.663,1.335h17.933c1.049,0,2.036-.495,2.663-1.335l7.173-9.624h1.242Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.341,112.57l-7.173,9.624c-.628,.84-1.614,1.335-2.663,1.335H21.572c-1.049,0-2.036-.495-2.663-1.335l-7.173-9.624H49.341Z",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.135 110.163 49.849 111.886 49.341 112.57 11.736 112.57 11.228 111.886 9.943 110.163 51.135 110.163",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.476 56.073 148.476 102.415 0 279.689 0 233.347 148.476 56.073",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.476,145.324v142.216c0,1.8-1.455,3.254-3.254,3.254H26.637l121.839-145.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.516 0 0 136.73 0 90.39 75.706 0 114.516 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.418 0 0 68.552 0 49.345 41.328 0 57.418 0",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridge);
export default __webpack_public_path__ + "static/media/fridge.a9fe942c4cc8954c3afdf7e8a762e56b.svg";
export { ForwardRef as ReactComponent };